import { render, staticRenderFns } from "./AccountsStatistics.vue?vue&type=template&id=4c3bb3f8&scoped=true&"
import script from "./AccountsStatistics.vue?vue&type=script&lang=js&"
export * from "./AccountsStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/statistics.styl?vue&type=style&index=0&id=4c3bb3f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3bb3f8",
  null
  
)

export default component.exports